import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { toast } from 'react-toastify';
import { LogoManualActionTypeLabels } from '../participationCancellationConstants';
import { formatMoneyWithCurrency } from '../../../utils/currencyDisplay';

const formatMoney = (amount) => formatMoneyWithCurrency(amount);

const LogoManualActionsPanel = ({
  open,
  onClose,
  actions = [],
  title = 'Logo manuel işlemler gerekli',
}) => {
  const [acknowledged, setAcknowledged] = useState(false);

  useEffect(() => {
    if (open) setAcknowledged(false);
  }, [open]);

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success('Kopyalandı');
    } catch {
      toast.error('Kopyalanamadı');
    }
  };

  const handleClose = () => {
    setAcknowledged(false);
    onClose();
  };

  const content = (
    <Stack spacing={2}>
      <Alert severity="warning" sx={{ fontSize: '13px' }}>
        Ödenmiş satırlar iptal edildi. Logo&apos;da aşağıdaki fişleri manuel olarak iptal edin veya düzeltin.
        Otomatik ters fiş oluşturulmaz.
      </Alert>
      {actions.map((action, index) => (
        <Card key={`${action.slipNo}-${index}`} variant="outlined" sx={{ boxShadow: 'none', borderColor: '#ececec' }}>
          <CardContent>
            <Stack spacing={1}>
              <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                {LogoManualActionTypeLabels[action.actionType] || action.actionType}
                {action.personLabel ? ` — ${action.personLabel}` : ''}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography sx={{ fontSize: '13px', color: '#666' }}>Fiş no:</Typography>
                <Typography
                  sx={{
                    fontSize: '13px',
                    fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
                    wordBreak: 'break-all',
                  }}
                >
                  {action.slipNo || '-'}
                </Typography>
                {action.slipNo && (
                  <IconButton size="small" onClick={() => handleCopy(action.slipNo)}>
                    <ContentCopyIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                )}
              </Stack>
              {action.amount != null && (
                <Typography sx={{ fontSize: '13px' }}>
                  Tutar: {formatMoney(action.amount)}
                </Typography>
              )}
              {action.message && (
                <Typography sx={{ fontSize: '13px', color: '#444' }}>{action.message}</Typography>
              )}
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );

  if (open != null) {
    return (
      <Dialog open={open} onClose={() => {}} maxWidth="sm" fullWidth disableEscapeKeyDown>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccountBalanceIcon sx={{ color: '#DFA000' }} />
          {title}
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 2 }}>
          {content}
          <FormControlLabel
            sx={{ mt: 2 }}
            control={(
              <Checkbox
                checked={acknowledged}
                onChange={(e) => setAcknowledged(e.target.checked)}
              />
            )}
            label="Logo işlemlerini not aldım"
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="contained"
            onClick={handleClose}
            disabled={!acknowledged}
            sx={{ textTransform: 'none', backgroundColor: '#0E4D94' }}
          >
            Anladım, kapattım
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Card variant="outlined" sx={{ boxShadow: 'none', borderColor: '#ececec' }}>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
          <AccountBalanceIcon sx={{ color: '#DFA000', fontSize: 20 }} />
          <Typography sx={{ fontSize: '15px', fontWeight: 600 }}>{title}</Typography>
        </Stack>
        {content}
      </CardContent>
    </Card>
  );
};

export default LogoManualActionsPanel;
